import React from "react";

export default function ChalanLogo() {
  return (
    <svg
      width="112"
      height="40"
      viewBox="0 0 112 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_203_3130)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M82.8454 18.801L87.4875 2.55352L67.9131 0L82.8454 18.801Z"
          fill="#E4126E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M88.1838 2.63066L102.729 21.973L85.9403 30.0194L83.8513 21.5089C83.8513 21.5089 83.3095 18.414 84.1605 16.0155L88.1838 2.63066Z"
          fill="#E2136E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M103.271 21.8183L97.8549 14.2361L106.985 12.6887L103.271 21.8183Z"
          fill="#D02052"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M107.681 12.6887L111.085 16.3251H106.133L107.681 12.6887Z"
          fill="#E2136E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M88.8801 29.4778L102.729 22.5919L102.265 24.2166L88.8801 29.4778Z"
          fill="#D02052"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M82.8454 20.503L77.0426 40L85.8627 33.0367L82.8454 20.503Z"
          fill="#A01337"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M75.4952 10.445L69.8472 3.24977L67.6808 3.32716L75.4952 10.445Z"
          fill="#A01337"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M83.7278 20.4334C83.7775 21.0856 83.8511 21.5089 83.8511 21.5089L85.9401 30.0194L102.729 21.973L102.576 21.7687L83.7278 20.4334Z"
          fill="#D02052"
        />
        <path
          d="M9.888 19.432L4.704 18.376V26.984C7.05067 24.6373 8.77867 22.12 9.888 19.432ZM14.56 20.616C13.8987 21.7253 13.184 22.856 12.416 24.008C11.648 25.1387 10.816 26.312 9.92 27.528C8.128 29.896 6.38933 31.1867 4.704 31.4H0V14.088V13.096H16.16V14.088H4.704V16.712L14.56 18.472V20.616Z"
          fill="#362B73"
        />
        <path
          d="M17.4375 14.088H15.5175V13.096H24.0615V14.088H22.1415V31.4H17.4375V14.088Z"
          fill="#362B73"
        />
        <path
          d="M33.1838 25.448C33.1838 25.64 33.1198 25.8853 32.9918 26.184C32.8851 26.4827 32.7357 26.8027 32.5437 27.144C32.3517 27.464 32.1491 27.784 31.9358 28.104C31.7224 28.4027 31.5197 28.6587 31.3277 28.872C31.0931 29.128 30.8371 29.3093 30.5598 29.416C30.3038 29.5013 30.0051 29.544 29.6637 29.544L26.7517 29.256C26.3464 29.2133 26.0051 29.0427 25.7277 28.744C25.4717 28.4453 25.3438 28.0827 25.3438 27.656V17.736C25.3438 17.6293 25.3864 17.5333 25.4718 17.448C25.5784 17.3413 25.7704 17.256 26.0478 17.192C26.3464 17.128 26.7518 17.0747 27.2638 17.032C27.7971 16.9893 28.5011 16.968 29.3757 16.968C30.3358 16.968 31.3917 17.0533 32.5437 17.224C33.7171 17.3947 34.8158 17.6827 35.8398 18.088C36.8638 18.472 37.7171 19.0053 38.3997 19.688C39.1037 20.3493 39.4557 21.1813 39.4557 22.184C39.4344 22.4187 39.4131 22.664 39.3918 22.92C39.3918 23.1547 39.3704 23.4 39.3278 23.656L39.1677 24.488L41.5358 23.272V14.088H23.4237V13.096H48.1598V14.088H46.2398V31.4H41.5358V26.472L38.0157 28.456V28.488L37.9837 28.456C37.6637 28.264 37.2691 28.0613 36.7998 27.848C36.3304 27.6133 35.8717 27.3893 35.4238 27.176C34.9971 26.9413 34.6344 26.7067 34.3358 26.472C34.0371 26.216 33.8877 25.9707 33.8877 25.736C33.8877 25.608 33.8984 25.512 33.9198 25.448C34.0904 24.9573 34.2291 24.4453 34.3358 23.912C34.4638 23.3573 34.5277 22.8347 34.5277 22.344C34.5277 21.7253 34.4104 21.224 34.1758 20.84C33.9411 20.456 33.6211 20.1573 33.2158 19.944C32.8104 19.7307 32.3411 19.592 31.8077 19.528C31.2957 19.4427 30.7411 19.4 30.1438 19.4V23.272H30.4638C30.7624 23.272 31.0717 23.304 31.3917 23.368C31.7117 23.4107 31.9998 23.5173 32.2558 23.688C32.5331 23.8373 32.7571 24.0613 32.9277 24.36C33.0984 24.6373 33.1838 25 33.1838 25.448Z"
          fill="#362B73"
        />
        <path
          d="M49.4375 14.088H47.5175V13.096H56.0615V14.088H54.1415V31.4H49.4375V14.088Z"
          fill="#362B73"
        />
        <path
          d="M73.4078 31.4H68.7038V23.944C67.8717 23.3253 66.9758 22.7707 66.0158 22.28C65.0558 21.768 63.8718 21.2133 62.4638 20.616V24.072C62.9544 24.1147 63.4131 24.2107 63.8398 24.36C64.2878 24.5093 64.6718 24.7227 64.9918 25C65.3331 25.256 65.5998 25.5653 65.7918 25.928C65.9838 26.2907 66.0798 26.696 66.0798 27.144C66.0798 27.72 65.9731 28.264 65.7598 28.776C65.5464 29.2667 65.2051 29.704 64.7358 30.088C64.2878 30.472 63.7118 30.7813 63.0078 31.016C62.3251 31.2293 61.5037 31.336 60.5437 31.336C60.1171 31.336 59.7011 31.304 59.2958 31.24C58.9118 31.176 58.5704 31.0587 58.2718 30.888C57.9944 30.7173 57.7704 30.4933 57.5997 30.216C57.4291 29.9173 57.3438 29.544 57.3438 29.096V18.12C58.0691 17.6933 58.9224 17.48 59.9037 17.48C60.5651 17.48 61.2904 17.5973 62.0798 17.832C62.8904 18.0453 63.6904 18.3227 64.4798 18.664C65.2904 19.0053 66.0584 19.3787 66.7838 19.784C67.5304 20.168 68.1704 20.52 68.7038 20.84V14.088H55.4238V13.096H75.3278V14.088H73.4078V31.4Z"
          fill="#362B73"
        />
      </g>
      <defs>
        <clipPath id="clip0_203_3130">
          <rect width="112" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
